import { createStore, applyMiddleware, combineReducers } from "redux";
import reduxLogger from "redux-logger";
import thunkMiddleware from "redux-thunk";


import SearchReducer from "./search/reducer";
import TicketsReducer from "./tickets/reducer";
import UserReducer from "./user/reducer";
import AppReducer from "./app/reducer";
import { __ENV__ } from '../config';
import CustomersReducer from './customers/reducer';
import RatingsReducer from "./ratings/reducer"

const reducers = combineReducers({
    customers: CustomersReducer,
    search: SearchReducer,
    ratings: RatingsReducer,
    tickets: TicketsReducer,
    user: UserReducer,
    app: AppReducer
});

const middlewares = [thunkMiddleware];
if (__ENV__ !== "production") {
    middlewares.push(reduxLogger);
}

export default createStore(reducers, applyMiddleware(...middlewares));